// extracted by mini-css-extract-plugin
export default {"subsectionTitle":"Seizures_subsectionTitle__9TRpO"};